var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#43B0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 22v-4m0-4h-.01M8 18c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10S8 23.523 8 18z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9IiM0M0IwRkYiLz4KPHBhdGggZD0iTTE4IDIyTDE4IDE4TTE4IDE0TDE3Ljk5IDE0TTggMThDOCAxMi40NzcyIDEyLjQ3NzIgOCAxOCA4QzIzLjUyMjggOCAyOCAxMi40NzcyIDI4IDE4QzI4IDIzLjUyMjggMjMuNTIyOCAyOCAxOCAyOEMxMi40NzcyIDI4IDggMjMuNTIyOCA4IDE4WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgCircleInfo as ReactComponent };